import { inject, provide, type InjectionKey } from 'vue'

import type { NotificationItemActionsResolver } from '../types/notification.types'

/**
 * app root ──provideNotificationItemActions(resolve)──▶ [injection]
 *                                                          │
 * NotificationList ──injectNotificationItemActions()──▶ #actions slot
 *
 * Provide/inject, not a store: the bell is mounted under TopBar, and the common
 * layer must not import a domain layer. Providers add actions only. Common owns
 * the row, the click, mark-as-read, and the row id.
 * A missing provider is normal (GoKollab, Meet) and returns no actions.
 */
const NOTIFICATION_ITEM_ACTIONS_KEY: InjectionKey<NotificationItemActionsResolver> = Symbol('notification-item-actions')

const noopResolver: NotificationItemActionsResolver = () => undefined

export function provideNotificationItemActions(resolve: NotificationItemActionsResolver): void {
  provide(NOTIFICATION_ITEM_ACTIONS_KEY, resolve)
}

export function injectNotificationItemActions(): NotificationItemActionsResolver {
  return inject(NOTIFICATION_ITEM_ACTIONS_KEY, noopResolver)
}
